import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=29f8ffc6&scoped=true"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"
import style0 from "./newPage.vue?vue&type=style&index=0&id=29f8ffc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f8ffc6",
  null
  
)

export default component.exports